/* The subject layer: the subjects chapters belong to, the routes a reader can
 * enter by, and the prerequisites the gate uses. Hand-written, never generated.
 */
import type { Route, Track } from '../types';

export const TRACKS: Track[] = [
  { id: 'decide', labelKey: 'routes:tracks.decide', chapters: ['what-ai-is'] },
  { id: 'models', labelKey: 'routes:tracks.models', chapters: ['model-families'] },
  { id: 'knowledge', labelKey: 'routes:tracks.knowledge', chapters: ['grounding', 'memory'] },
  { id: 'events', labelKey: 'routes:tracks.events', chapters: ['event-bus'] },
  { id: 'services', labelKey: 'routes:tracks.services', chapters: ['service-split'] },
  { id: 'frontend', labelKey: 'routes:tracks.frontend', chapters: ['frontend-composition'] },
  { id: 'assure', labelKey: 'routes:tracks.assure', chapters: ['tooling', 'guardrails'] },
  { id: 'operate', labelKey: 'routes:tracks.operate', chapters: ['evaluate', 'production'] },
  { id: 'deliver', labelKey: 'routes:tracks.deliver', chapters: ['deploy', 'monitor'] },
];

export const ROUTES: Route[] = [
  {
    id: 'full',
    labelKey: 'routes:routes.full.label',
    whoKey: 'routes:routes.full.who',
    entry: 'what-ai-is',
    chapters: [
      'what-ai-is',
      'model-families',
      'grounding',
      'memory',
      'event-bus',
      'service-split',
      'frontend-composition',
      'tooling',
      'guardrails',
      'evaluate',
      'production',
      'deploy',
      'monitor',
    ],
  },
  {
    id: 'decide',
    labelKey: 'routes:routes.decide.label',
    whoKey: 'routes:routes.decide.who',
    entry: 'what-ai-is',
    chapters: ['what-ai-is', 'model-families'],
  },
  {
    id: 'knowledge',
    labelKey: 'routes:routes.knowledge.label',
    whoKey: 'routes:routes.knowledge.who',
    entry: 'grounding',
    chapters: ['model-families', 'grounding', 'memory'],
  },
  {
    id: 'integrate',
    labelKey: 'routes:routes.integrate.label',
    whoKey: 'routes:routes.integrate.who',
    entry: 'event-bus',
    chapters: ['event-bus', 'service-split', 'guardrails'],
  },
  {
    id: 'frontend',
    labelKey: 'routes:routes.frontend.label',
    whoKey: 'routes:routes.frontend.who',
    entry: 'frontend-composition',
    chapters: ['model-families', 'frontend-composition'],
  },
  {
    id: 'tooling',
    labelKey: 'routes:routes.tooling.label',
    whoKey: 'routes:routes.tooling.who',
    entry: 'tooling',
    chapters: ['what-ai-is', 'tooling'],
  },
  {
    id: 'operate',
    labelKey: 'routes:routes.operate.label',
    whoKey: 'routes:routes.operate.who',
    entry: 'evaluate',
    chapters: ['event-bus', 'service-split', 'guardrails', 'evaluate', 'production', 'deploy', 'monitor'],
  },
];

/* From the artifact's own cross-chapter references (data/carry.ts) and the
 * optional stages' parents; every other connector is order, not requirement. */
export const PREREQ: Record<string, string[]> = {
  grounding: ['model-families'],
  memory: ['grounding'],
  'service-split': ['event-bus'],
  'frontend-composition': ['model-families'],
  tooling: ['what-ai-is'],
  guardrails: ['service-split'],
  evaluate: ['guardrails'],
  production: ['evaluate'],
  deploy: ['production'],
  monitor: ['deploy'],
  'x-curriculum': ['what-ai-is'],
  'x-softmax': ['model-families'],
  'x-delivery': ['event-bus'],
  'x-contracts': ['service-split'],
  'x-threats': ['guardrails'],
  'x-drift': ['evaluate'],
  'x-cost': ['production'],
  'x-agents': ['tooling'],
  'x-structured': ['guardrails'],
  'x-compliance': ['production'],
  'x-latency': ['production'],
  'x-nats': ['event-bus'],
  'x-federation': ['frontend-composition'],
};
